// extracted by mini-css-extract-plugin
export var leftAlign = "_37-2";
export var popper = "_37-0";
export var subtitle = "_37-1";